import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  Autocomplete,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Checkbox,
  Box
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AddLocationAltRoundedIcon from '@mui/icons-material/AddLocationAltRounded';
import axios from '../../axiosConfig';
import './animation.css';

// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: '#424242',
  fontWeight: '600',
  // textAlign: 'center',
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ProdutionUnitMasters = () => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ'
  );
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  // alert messages on operations
  const [alertType, setAlertType] = useState('success'); // 'success' or 'error'
  const [alertMessage, setAlertMessage] = useState('');

  const [errors, setErrors] = useState({
    unitName: false,
    address: false,
    Country: false,
    Email: false,
    Contactperson: false,
    contactNo: false,
    Active: false,
  });
  const [helperTexts, setHelperTexts] = useState({
    unitName: '',
    address: '',
    Country: '',
    Email: '',
    Contactperson: '',
    contactNo: '',
    Active: '',
  });

  // input fields state values
  const [unitName, setunitName] = useState('');
  const [address, setaddress] = useState('');
  const [countryData, setCountryData] = useState('');
  const [Email, setEmail] = useState('');
  const [Contactperson, setContactperson] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [Active, setActive] = useState('Y');
  const [unitData, setunitData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [editID, setEditID] = useState();
  const [IdToDelete, setIdToDelete] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [logData, setLogData] = useState([]);
  const [lineData, setLineData] = useState([]);

  // API Integration
  useEffect(() => {
    getAllUnits();
    getCountries();
    GetAllActiveCompany();
    GetAllActiveLine();
  }, []);

  // get all active company
  const GetAllActiveCompany = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveCompany', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setCompanyData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Cities Request
  const getCountries = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllCountry', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setCountryData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Users Request
  const getAllUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllProductionUnits', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setunitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // get all Active Line
  const GetAllActiveLine = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllLineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // post Request to Add new record
  const InsertProductionUnitMst = async (newData) => {
    try {
      const res = await axios.instance.post('/InsertProductionUnitMst', newData, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      DeleteAndInsertLogs(res.data[0].Unit_Id);
      getAllUnits();
      setAlertType('success');
      setAlertMessage(
        operation === 'Edit' ? 'Production Unit updated Successfully!' : 'New Production Unit Added Successfully!'
      );
      setopenAlert(true);
    } catch (error) {
      console.error('Error adding Production Unit:', error);
      setAlertType('error');
      setAlertMessage(
        operation === 'Edit' ? 'Failed to Update the Production Unit!' : 'Failed to add the Production Unit!'
      );
      setopenAlert(true);
    }
  };

  // delete Request to delete record
  const DeleteProductionUnitMst = async (DelId) => {
    try {
      await axios.instance
        .delete(`/DeleteProductionUnitMst/${DelId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            DeleteAllLogs(DelId);
            getAllUnits();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Production Unit Deleted Successfully!');
            setopenAlert(true);
          } else {
            getAllUnits();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting Production Unit:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the Production Unit.');
      setopenAlert(true);
    }
  };

    // get all Users Request
    const GetOneCompanyLog = async (id) => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`/GetOneUnitLineLog/${id}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        setLogData(res.data);
        setOpenLoader(false);
        console.log('users', res.data);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

  const DeleteAndInsertLogs = (unitid) => {
    setOpenLoader(true);
    return axios.instance
      .delete(`/DeleteUnitLineAllLogs/${unitid}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(() => {
        const detailPromises = logData.map((obj) => {
          const insertData = {
            // ...obj,
            Unit_Id: unitid,
            Unit_Name: unitName,
            Line_Id: obj.Line_id,
            Line_Name: obj.Line_Name,
            CreatedBy: sessionStorage.getItem('UserID'),
          };

          return axios.instance.post('/InsertUnitLineLogDtl', insertData, {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          });
        });

        return Promise.all(detailPromises)
          .then((detailRes) => {
            // setAlertType('success');
            // setAlertMessage('Line Logs Updated Successfully!');
            // setopenAlert(true);
            resetFields();
            setTimeout(() => {
              setopenAlert(false);
              setOpenLoader(false);
            }, 2000);
            return detailRes;
          })
          .catch((error) => {
            // console.error('Error adding detail data:', error);
            // setAlertType('error');
            // setAlertMessage('Failed to add line data.');
            setOpenLoader(false);
            // setopenAlert(true);
            return Promise.reject(error);
          });
      })
      .catch((error) => {
        console.error('Error deleting access:', error);
        setAlertType('error');
        setAlertMessage('Failed to delete access.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  // delete details only for company log
  const DeleteAllLogs = async (userId) => {
    try {
      await axios.instance
        .delete(`/DeleteUnitLineAllLogs/${userId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            setOpenDelete(false);
          } else {
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
          console.log(res.data);
        });
    } catch (error) {
      console.error('Error deleting User:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the User.');
      setopenAlert(true);
    }
  };

  const resetFields = () => {
    setunitName('');
    setaddress('');
    setEmail('');
    setContactNo('');
    setActive('');
    errors.unitName = false;
    errors.address = false;
    errors.Email = false;
    errors.contactNo = false;
    errors.Contactperson = false;
    errors.UserPassword = false;
    errors.Active = false;
    helperTexts.unitName = '';
    helperTexts.address = '';
    helperTexts.Email = '';
    helperTexts.contactNo = '';
    helperTexts.Contactperson = '';
    helperTexts.Active = '';
    helperTexts.logSelected = false;
    setSelectedCountry(null);
    setSelectedCompany(null)
    setContactperson('');
    setLogData([])
  };

  // submit button on add or edit
  const handleSubmit = (event) => {
    event.preventDefault();
    const inputValidation =
      errors.unitName ||
      errors.address ||
      errors.Email ||
      errors.Country ||
      errors.Contactperson ||
      errors.contactNo ||
      errors.Active ||
      errors.Company ||
      !unitName ||
      !address ||
      !selectedCountry ||
      !Active ||
      !selectedCompany ||
      (logData.length === 0);

    if (inputValidation) {
      if (!unitName) {
        setErrors((prevErrors) => ({ ...prevErrors, unitName: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          unitName: 'Please Enter Production Unit Name',
        }));
      }
      if (!address) {
        setErrors((prevErrors) => ({ ...prevErrors, address: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          address: 'Please Enter Address',
        }));
      }
      if (!selectedCountry) {
        setErrors((prevErrors) => ({ ...prevErrors, Country: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Country: 'Please Select Country',
        }));
      }
      if (!selectedCompany) {
        setErrors((prevErrors) => ({ ...prevErrors, Company: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Company: 'Please Select Company',
        }));
      }
      if (!logData || logData.length === 0) {
        setErrors((prevErrors) => ({ ...prevErrors, logSelected: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          logSelected: 'Please Add line/batch',
        }));
      }
      if (!Active) {
        setErrors((prevErrors) => ({ ...prevErrors, Active: true }));
        setHelperTexts((prevHelperTexts) => ({
          ...prevHelperTexts,
          Active: 'Please select Active Status',
        }));
      }
    }
    if (inputValidation) {
      return;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      unitName: false,
      address: false,
      Country: false,
      Email: false,
      Contactperson: false,
      contactNo: false,
      Active: false,
      Company: false
    }));

    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      unitName: '',
      address: '',
      Country: '',
      Email: '',
      Contactperson: '',
      contactNo: '',
      Active: '',
      Company: ''
    }));

    const newData = {
      optype: operation === 'Edit' ? 'Edit' : 'Add',
      Unit_Id: operation === 'Edit' ? editID : '',
      Unit_Name: unitName,
      Address: address,
      Country: selectedCountry.id,
      CompanyId: selectedCompany.Company_Id,
      Email_Id: Email,
      Contact_Person: Contactperson,
      Contact_No: contactNo,
      Active,
      [operation === 'Edit' ? 'ModifyedBy' : 'CreatedBy']: sessionStorage.getItem('UserID'),
    };
    console.log(newData, 'newData')
    InsertProductionUnitMst(newData);
    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'unitName') setunitName(value);
    if (name === 'address') setaddress(value);
    if (name === 'Email') setEmail(value);
    if (name === 'contactNo') setContactNo(value);
    if (name === 'Contactperson') setContactperson(value);
    if (name === 'Active') setActive(value);
    validateInput(name, value);
  };

  // validations

  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const contactRegex = /^\d{10}$/;

    const isDataExists = unitData.some((data) => data.Unit_Name.toLowerCase() === value.toLowerCase().trim());
    const isDataExistsinEdit = unitData.some(
      (data) => data.Unit_Name.toLowerCase() === value.toLowerCase().trim() && data.Unit_Id !== editID
    );
    console.log(isDataExists, isDataExistsinEdit, 'Name');

    if (name === 'unitName') {
      if (!value.trim()) {
        error = true;
        helperText = 'Production Unit Name field cannot be empty';
        setIsFormSubmitted(false);
      } else if (operation === 'Add' && isDataExists) {
        error = true;
        helperText = 'Production Unit Name already exists';
        setIsFormSubmitted(false);
      } else if (operation === 'Edit' && isDataExistsinEdit) {
        error = true;
        helperText = 'Production Unit Name already exists';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'address') {
      if (!value.trim()) {
        error = true;
        helperText = 'address  cannot be empty';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'Email') {
      if (value.length > 0 && !emailRegex.test(value)) {
        error = true;
        helperText = 'please enter a valid email';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    } else if (name === 'contactNo') {
      if (value.length > 0 && !contactRegex.test(value) && value.length > 10) {
        error = true;
        helperText = 'cannot exceed more than 10 numbers';
        setIsFormSubmitted(false);
      } else if (value.length > 0 && value.length < 10) {
        error = true;
        helperText = 'enter 10 digit mobile numbers';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }
    // else if (name === 'Contactperson') {
    //   if (!value.trim()) {
    //     error = true;
    //     helperText = 'Contact person field cannot be empty';
    //     setIsFormSubmitted(false);
    //   } else {
    //     setIsFormSubmitted(true);
    //   }
    // }
    else if (name === 'Active') {
      if (!value.trim()) {
        error = true;
        helperText = 'Plaese select user status';
        setIsFormSubmitted(false);
      } else {
        setIsFormSubmitted(true);
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
    setHelperTexts((prevHelperTexts) => ({
      ...prevHelperTexts,
      [name]: helperText,
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value.length > 0) {
      validateInput(name, value);
    }
  };

  // handle edit popup dialog
  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
  };

  const handleEdit = (datas) => {
    setEditID(datas.Unit_Id);
    GetOneCompanyLog(datas.Unit_Id);
    setunitName(datas.Unit_Name);
    setaddress(datas.Address);
    setEmail(datas.Email_Id);
    setContactNo(datas.Contact_No);
    setContactperson(datas.Contact_Person);
    const selectedCountryObj = countryData.find((cntry) => parseInt(cntry.id, 10) === parseInt(datas.Country, 10));
    setSelectedCountry(selectedCountryObj);
    const selectedCompanyObj = companyData.find((cntry) => parseInt(cntry.Company_Id, 10) === parseInt(datas.CompanyId, 10));
    setSelectedCompany(selectedCompanyObj)
    setActive(datas.Active);
    handleEditOpen();
    console.log(selectedCountryObj, 'edit data', datas);
  };

  const handleEditOpen = () => {
    setOpen(true);
    setOperation('Edit');
  };

  const handleDelete = (idDel) => {
    setOpenDelete(true);
    setIdToDelete(idDel);
  };

  const handleDeleteConfirmed = (idtoDel) => {
    DeleteProductionUnitMst(idtoDel);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  // search & filter
  const filteredData = unitData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  const handleInputChangeSelect = (event, newValue) => {
    setSelectedCountry(newValue);

    if (!newValue) {
      // Check if the newValue is null or undefined
      setErrors((prevErrors) => ({ ...prevErrors, Country: true }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Country: 'Please select a country' }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, Country: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Country: '' }));
    }
  };

  const handleCompanyInputChangeSelect = (event, newValue) => {
    if (newValue) {
      setSelectedCompany(newValue);

      if (!newValue) {
        // Check if the newValue is null or undefined
        setErrors((prevErrors) => ({ ...prevErrors, Company: true }));
        setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Company: 'Please select a company' }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, Country: false }));
        setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, Company: '' }));
      }
    }
  };

  // pagination
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredData.length - page * rowsPerPage);
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1)); // Clamp to the range [0, totalPages - 1]
  // Reset page to 0 when searchTerm changes
  useEffect(() => {
    setPage(0);
  }, [searchTerm]);

  const handleChangeSelection = (event, newValue) => {
    setLogData(newValue);
    console.log(!newValue, 'newValue')
    if (!newValue) {
      setErrors((prevErrors) => ({ ...prevErrors, logSelected: true }));
      setHelperTexts((prevHelperTexts) => ({
        ...prevHelperTexts,
        logSelected: 'please select & add Line in list',
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, logSelected: false }));
      setHelperTexts((prevHelperTexts) => ({ ...prevHelperTexts, logSelected: '' }));
    }
  };

  const availableLines = lineData.filter(
    (line) => !logData.some((selected) => selected.Line_id === line.Line_id)
  );

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Production Unit Master
            </Typography>
          </Typography>
        </Grid>

        {/* table header */}
        {/* <Typography variant="h6" color="primary" fontWeight={600} mb={2} textAlign="center" sx={{ color: '#616161' }}>
          Production Unit Master
        </Typography> */}

        {/* search & add button */}
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={2} my={2}>
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
          />
          <Button
            variant="outlined"
            color="secondary"
            sx={{ boxShadow: 1 }}
            onClick={handleAddOpen}
            startIcon={<PlaylistAddIcon />}
          >
            Add Production Unit
          </Button>
        </Stack>

        {/* table  */}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Production Unit</StyledTableCell>
                <StyledTableCell align="left">Address</StyledTableCell>
                <StyledTableCell align="left">Email</StyledTableCell>
                <StyledTableCell align="left">Contact Person</StyledTableCell>
                <StyledTableCell align="left">Contact No</StyledTableCell>
                <StyledTableCell align="left">Country</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
              ).map((datas, index) => (
                <TableRow key={datas.UserAccessID} hover>
                  <TableCell align="center">{datas.SNo}</TableCell>
                  <TableCell align="left">{datas.Unit_Name}</TableCell>
                  <TableCell align="left">{datas.Address}</TableCell>
                  <TableCell align="left">{datas.Email_Id}</TableCell>
                  <TableCell align="left">{datas.Contact_Person}</TableCell>
                  <TableCell align="left">{datas.Contact_No}</TableCell>
                  <TableCell align="left">{datas.country_name}</TableCell>
                  <TableCell align="center">
                    {datas.Active === 'Y' ? (
                      <Chip icon={<CheckCircleOutlineIcon />} color="success" size="small" label="Active" />
                    ) : (
                      <Chip icon={<HighlightOffIcon />} color="error" size="small" label="InActive" />
                    )}
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton aria-label="Edit" onClick={() => handleEdit(datas)}>
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton aria-label="Delete" onClick={() => handleDelete(datas.Unit_Id)}>
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={9} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
      </Container>

      <Grid m={2}>
        {/* add new popup form dialog box */}
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} fullWidth>
          <Container component={Paper} elevation={2} sx={{ py: 2 }}>
            <form onSubmit={handleSubmit} noValidate>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h5" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {operation} Production Unit
                </Typography>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack direction={'column'} spacing={2} p={2}>
                <Autocomplete
                  size="small"
                  name="Company"
                  options={companyData}
                  getOptionLabel={(cntry) => (cntry ? cntry.Company_Name : '')}
                  value={selectedCompany || null}
                  onChange={handleCompanyInputChangeSelect}
                  renderInput={(params) => <TextField {...params} label="Select Company" required />}
                  disableClearable
                />
                {errors.Company && (
                  <Typography
                    variant="caption"
                    color="error"
                    className={isFormSubmitted && errors.Company ? 'shake-helper-text' : ''}
                  >
                    {errors.Company && helperTexts.Company}
                  </Typography>
                )}
                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Production Unit Name"
                  name="unitName"
                  value={unitName === null ? '' : unitName}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  required
                  size="small"
                  error={errors.unitName}
                  helperText={helperTexts.unitName}
                  className={isFormSubmitted && errors.unitName ? 'shake-helper-text' : ''}
                />

                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  fullWidth
                  options={availableLines}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.Line_Name}
                  value={logData}
                  onChange={handleChangeSelection}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        {/* <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        /> */}
                        {option.Line_Name}
                      </li>
                    );
                  }}
                  // renderTags={(selected, getTagProps) =>
                    
                  //   selected.map((option, index) => (
                  //     <Chip
                  //       key={index}
                  //       color="primary"
                  //       size="small"
                  //       variant="outlined"
                  //       label={option.Line_Name}
                  //       {...getTagProps({ index })}
                  //       onDelete={() => {
                  //         const newSelected = selected.filter((sel) => sel.Line_id !== option.Line_id);
                  //         setLogData(newSelected);
                  //       }}
                  //     />
                  //   ))
                  // }
                  renderTags={(selected, getTagProps) => (
                      <Box
                        sx={{
                          maxHeight: 70,   // prevent overflow
                          overflowY: "auto",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.5,
                        }}
                      >
                        {selected.map((option, index) => (
                          <Chip
                            key={index}
                            size="small"
                            label={option.Line_Name}
                            {...getTagProps({ index })}
                          />
                        ))}
                      </Box>
                    )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Line/Batch Name"
                      placeholder="add line"
                      required
                      error={Boolean(errors.logSelected)} // Add error prop here
                      helperText={errors.logSelected && helperTexts.logSelected}
                      InputProps={{
                        ...params.InputProps,
                        className: errors.logSelected ? 'error-border' : '',
                      }}
                    />
                  )}
                />
                {/* {errors.logSelected && (
                  <Typography
                    variant="caption"
                    color="error"
                    className={isFormSubmitted && errors.logSelected ? 'shake-helper-text' : ''}
                    pl={2}
                    mt={6}
                  >
                    {errors.logSelected && helperTexts.logSelected}
                  </Typography>
                )} */}

                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Address"
                  name="address"
                  required
                  value={address === null ? '' : address}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  multiline
                  rows={3}
                  error={errors.address}
                  helperText={helperTexts.address}
                  className={isFormSubmitted && errors.address ? 'shake-helper-text' : ''}
                />

                <Autocomplete
                  size="small"
                  name="Country"
                  options={countryData}
                  getOptionLabel={(cntry) => (cntry ? cntry.country_name : '')}
                  value={selectedCountry || null}
                  onChange={handleInputChangeSelect}
                  renderInput={(params) => <TextField {...params} label="Select Country" required />}
                />
                {errors.Country && (
                  <Typography
                    variant="caption"
                    color="error"
                    className={isFormSubmitted && errors.Country ? 'shake-helper-text' : ''}
                  >
                    {errors.Country && helperTexts.Country}
                  </Typography>
                )}

                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Email"
                  name="Email"
                  value={Email === null ? '' : Email}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  error={errors.Email}
                  helperText={helperTexts.Email}
                  className={isFormSubmitted && errors.Email ? 'shake-helper-text' : ''}
                />

                <TextField
                  type="text"
                  variant="outlined"
                  color="primary"
                  label="Contact Person"
                  name="Contactperson"
                  value={Contactperson === null ? '' : Contactperson}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  error={errors.Contactperson}
                  helperText={helperTexts.Contactperson}
                  className={isFormSubmitted && errors.Contactperson ? 'shake-helper-text' : ''}
                />

                <TextField
                  type="number"
                  variant="outlined"
                  color="primary"
                  label="Contact No"
                  name="contactNo"
                  value={contactNo === null ? '' : contactNo}
                  onBlur={handleBlur}
                  onChange={handleInputChange}
                  fullWidth
                  size="small"
                  error={errors.contactNo}
                  helperText={helperTexts.contactNo}
                  className={isFormSubmitted && errors.contactNo ? 'shake-helper-text' : ''}
                />

                <FormControl size="small" fullWidth component="fieldset">
                  <FormLabel component="legend">Status</FormLabel>
                  <RadioGroup row value={Active} name="Active" onChange={handleInputChange}>
                    <FormControlLabel value="Y" control={<Radio />} label="Active" />
                    <FormControlLabel value="N" control={<Radio />} label="InActive" />
                  </RadioGroup>
                  {errors.Active && (
                    <Typography
                      variant="caption"
                      color="error"
                      className={isFormSubmitted && errors.Active ? 'shake-helper-text' : ''}
                    >
                      {errors.Active && helperTexts.Active}
                    </Typography>
                  )}
                </FormControl>
                <Button type="submit" variant="contained" color="primary" size="small" sx={{ boxShadow: 1 }} fullWidth>
                  Save
                </Button>
              </Stack>
            </form>
          </Container>
        </Dialog>
      </Grid>

      {/* confirmation dialog */}
      <Dialog
        open={openDelete}
        onClose={handleCloseDelete}
        aria-labelledby="responsive-dialog-title"
        fullScreen={fullScreen}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button variant="contained" onClick={() => handleDeleteConfirmed(IdToDelete)} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default ProdutionUnitMasters;
